module.exports = __webpack_public_path__ + "NexaBlack.05276cc4226799fea28a.svg";


//////////////////
// WEBPACK FOOTER
// D:/ptrans/front-end-customer/src/assets/fonts/NexaBlack.svg
// module id = ../../../../../src/assets/fonts/NexaBlack.svg
// module chunks = 2